import { useState } from 'react';

const testimonials = [
  {
    text: 'Trabajar con Paty fue la mejor decisión para mi marca. En solo 3 meses duplicamos nuestros seguidores y las ventas por Instagram aumentaron un 150%. Su creatividad y estrategia son increíbles.',
    name: 'María González',
    role: 'Fundadora de Belleza Natural',
    avatar: 'https://public.readdy.ai/ai/img_res/331003f1191b32902e7dce44fe0be668.jpg'
  },
  {
    text: 'Paty no solo maneja mis redes, ella entiende mi marca y mi audiencia. El contenido que crea es auténtico, creativo y genera resultados reales. Mi comunidad creció de forma orgánica y genuina.',
    name: 'Laura Martínez',
    role: 'Coach de Vida',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20young%20woman%20smiling%2C%20life%20coach%2C%20wellness%20professional%2C%20approachable%20friendly%20look%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-2&orientation=squarish'
  },
  {
    text: 'La asesoría con Paty cambió completamente mi estrategia en redes sociales. Ahora sé exactamente qué publicar, cuándo y cómo conectar con mi audiencia. Los resultados hablan por sí solos.',
    name: 'Ana Rodríguez',
    role: 'Dueña de Boutique Online',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20woman%20smiling%20confidently%2C%20fashion%20entrepreneur%2C%20boutique%20owner%2C%20elegant%20professional%20look%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-3&orientation=squarish'
  },
  {
    text: 'El lanzamiento de mi nuevo producto fue un éxito total gracias a la campaña que Paty diseñó. Vendimos todo el stock en 48 horas. Su visión estratégica es impresionante.',
    name: 'Sofía Ramírez',
    role: 'Emprendedora',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20entrepreneur%20woman%20smiling%2C%20startup%20founder%2C%20innovative%20businesswoman%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-4&orientation=squarish'
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-white via-pink-50 to-white relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        {/* Título */}
        <div className="text-center mb-16 relative">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-8 text-9xl text-pink-100 font-serif">"</div>
          <h2 className="text-4xl md:text-5xl font-bold text-purple-900 relative z-10">
            Lo que dicen mis clientas
          </h2>
        </div>

        {/* Carrusel */}
        <div className="relative">
          <div className="flex items-center justify-center gap-8">
            {/* Tarjeta anterior (parcial) */}
            <div className="hidden lg:block w-80 opacity-30 transform scale-90">
              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <div className="h-40"></div>
              </div>
            </div>

            {/* Tarjeta activa */}
            <div className="w-full max-w-2xl">
              <div className="bg-white rounded-[32px] p-10 md:p-12 shadow-2xl relative">
                {/* Badge de calificación */}
                <div className="absolute top-8 left-8 px-4 py-2 bg-purple-900 text-white rounded-full flex items-center gap-2">
                  <i className="ri-star-fill text-yellow-400"></i>
                  <span className="font-bold">5.0</span>
                </div>

                {/* Texto del testimonio */}
                <div className="mt-12 mb-8">
                  <p className="text-gray-700 text-lg md:text-xl leading-relaxed font-serif italic">
                    {testimonials[currentIndex].text}
                  </p>
                </div>

                {/* Información del usuario */}
                <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                  <div className="w-14 h-14 rounded-full overflow-hidden">
                    <img
                      src={testimonials[currentIndex].avatar}
                      alt={testimonials[currentIndex].name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-purple-900">
                      {testimonials[currentIndex].name}
                    </h4>
                    <p className="text-gray-600 text-sm">
                      {testimonials[currentIndex].role}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Tarjeta siguiente (parcial) */}
            <div className="hidden lg:block w-80 opacity-30 transform scale-90">
              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <div className="h-40"></div>
              </div>
            </div>
          </div>

          {/* Controles de navegación */}
          <div className="flex items-center justify-center gap-4 mt-12">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 rounded-full border-2 border-pink-500 text-pink-500 flex items-center justify-center hover:bg-pink-50 transition-all cursor-pointer"
              aria-label="Anterior testimonio"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>

            {/* Indicadores de puntos */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`h-2 rounded-full transition-all cursor-pointer ${
                    index === currentIndex
                      ? 'w-8 bg-gradient-to-r from-pink-500 to-purple-600'
                      : 'w-2 bg-gray-300'
                  }`}
                  aria-label={`Ir al testimonio ${index + 1}`}
                ></button>
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 text-white flex items-center justify-center hover:shadow-lg transition-all cursor-pointer"
              aria-label="Siguiente testimonio"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
